const userSubscribeStatusLoading = () => (dispatch) => {
  dispatch({
    type: 'USER_SUBSCRIBE_STATUS_LOADING',
  });
};

export default userSubscribeStatusLoading;
